import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { DoodApiError } from '@shared/interfaces/error.interface';
import { CrossSellingData } from './cross-selling.state';

export const CROSS_SELLING_STORE_API_ACTIONS = createActionGroup({
  source: 'Dood/API/CrossSelling',
  events: {
    'Load CrossSelling': props<{
      triggerProductId: string;
      triggerProductShopId: string;
      order: any;
    }>(),
    'Load CrossSelling Loading': emptyProps(),
    'Load CrossSelling Success': props<CrossSellingData>(),
    'Load CrossSelling Failure': props<{ error: DoodApiError }>(),
    'Load CrossSelling Complete': emptyProps(),
  },
});
